module.exports = __webpack_public_path__ + "media/images/bsmart/icons/scheda_verifica_materia-084023b48b51486bdb5b4f1350c6a207.svg";